<template>
  <v-list-tile class="my-2" ref="targetModal">
    <v-list-tile-avatar style="min-width: 40px" class="mr-1">
      <v-icon color="tree" >{{item.icon}}</v-icon>
      <v-tooltip color="secondary" v-if="res_prod.lenght > 0 && res_prod['ore'] < 120 && item.is_abbonamento == 1" left dark style="opacity: 1;">
        <v-icon  slot="activator" color="red">fas fa-exclamation-triangle</v-icon>
        <span v-if="!item.km">Richiesta di abbonamento con meno di 120 ore lavorate</span>
      </v-tooltip>
    </v-list-tile-avatar>

    <v-list-tile-content class="title__wrap">
      <v-list-tile-title class="subheading font-weight-bold secondary--text">
          {{ item.descrizione_categoria.toUpperCase() }}
          <v-chip v-if='isAuto' outline label color="tree" text-color="tree">
            <v-icon size="14" left>label</v-icon> {{item.targa}}
          </v-chip>
        <v-tooltip color="secondary" right>
            <v-icon slot="activator" right v-if="isAbbonamento" dark small color="light-blue darken-4">fas fa-credit-card</v-icon>
            <span>Abbonamento</span>
      </v-tooltip>
        <v-tooltip color="secondary" right>
            <v-icon slot="activator" right v-if="superaMax" dark small color="red">fas fa-exclamation-triangle</v-icon>
            <span>Supera max importo {{item.max_importo}} €</span>
      </v-tooltip>
      </v-list-tile-title>
      <v-list-tile-title class="body-2" style="display: flex;">
           {{ importo }} €
          <span v-if="item.is_lek !== null && item.is_lek != 0"> ({{ lek }} L) </span>
          <v-chip v-if='isAuto' outline label color="tree" text-color="tree">
            {{km}} km
          </v-chip>
          <v-chip v-if='isAuto' outline label color="tree" text-color="tree">
            {{item.titolo}}
          </v-chip>
          <v-tooltip right color="white" style="opacity: 1;" v-if="img">
            <v-icon right size="18" slot="activator" @click.stop="showImgPrew">fas fa-file-invoice</v-icon>
            <span>
              <img v-if="!isPDF" :src="imgPath" width="250">
              <embed v-else :src="imgPath" width="500" height="375" type="application/pdf">
            </span>
          </v-tooltip>
      </v-list-tile-title>
      <v-list-tile-sub-title
        v-if="item.concat"
        v-html="item.concat.split('->').join('<br>')"
        class="caption"
      ></v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action
      v-if="item.stato == 0 && item.flag_da_aggiornare != 1 && Boolean(+item.importo) && !readonly"
    >
      <v-btn fab dark small color="success" @click.stop="changeStato(item, 'CONFIRM')">
        <v-icon small dark>fas fa-check</v-icon>
      </v-btn>
    </v-list-tile-action>
    <v-list-tile-action
      v-if="item.stato == 0 && item.flag_da_aggiornare != 1 && Boolean(+item.importo) && !Boolean(+item.is_anticipata_azienda) && !readonly"
    >
      <v-btn fab outline small color="warning" @click.stop="changeStato(item, 'MODIFY')">
        <v-icon small dark>fas fa-pen</v-icon>
      </v-btn>
    </v-list-tile-action>
    <v-list-tile-action
      v-if="item.stato == 0 && item.flag_da_aggiornare != 1 && Boolean(+item.importo) && !readonly"
    >
      <v-btn fab outline small color="red" @click.stop="changeStato(item, 'CANCEL')">
        <v-icon small dark>fas fa-ban</v-icon>
      </v-btn>
    </v-list-tile-action>
    <v-list-tile-action
      v-if="item.stato != 0 && item.flag_da_aggiornare != 1 && Boolean(+item.importo)"
    >
      <v-chip v-if="item.stato == 1" label outline color="green darken-4">Confermato GM</v-chip>
      <v-chip v-if="item.stato == 4" label outline color="green lighten-3">Confermato SAMM</v-chip>
      <v-chip v-if="item.stato == 2" label outline color="red">Annullato GM</v-chip>
      <v-chip v-if="item.stato == 5" label outline color="red">Annullato SAMM</v-chip>
      <v-chip v-if="item.stato == 3" label outline color="orange">
        Attesa modifica
        <v-tooltip color="secondary" right z-index="299" max-width="150">
          <v-icon size="16" color="orange darken-4" right dark slot="activator">fa-info</v-icon>
          <span v-text="item.motivo_no_conferma"></span>
        </v-tooltip>
      </v-chip>
    </v-list-tile-action>
    <v-list-tile-action v-if="item.flag_da_aggiornare == 1 || !Boolean(+item.importo)">
      <v-tooltip color="secondary" right dark style="opacity: 1;">
        <v-icon slot="activator" color="red">fas fa-exclamation-triangle</v-icon>
        <span v-if="!item.km">Verifica la tratta: {{item.concat}}</span>
        <span v-if="item.flag_da_aggiornare == 1">Verifica la macchina con targa: {{item.targa}}</span>
      </v-tooltip>
    </v-list-tile-action>
    <ImagePdfPreview
        v-if="img"
      :src="imgPath"
      :name="item.img"
      :show="imgPrev"
      @on-click-close="closeImgPrewHandler"
    ></ImagePdfPreview>
  </v-list-tile>
</template>

<script>
import ImagePdfPreview from "./ImagePdfPreview.vue";

export default {
  name: "acc-verifica-note-dettaglio-item",
  components: { ImagePdfPreview },
  props: {
    item: {
      type: Object
    },
    readonly: {
      type: Boolean,
      default: false
    },
    res_prod:{
      type: Object
    }
  },
  data: () => ({
    imgPrev: false
  }),
  computed: {
      isAuto () {
          return Boolean(this.item.targa)
      },
      isAbbonamento() {
          return Boolean(+this.item.is_abbonamento)
      },
      superaMax () {
          return +this.item.max_importo > 0 && +this.item.importo > +this.item.max_importo
      },
      img () {
          return this.isAuto ? this.item.img_libretto : this.item.img
      },
      imgPath () {
          return this.$store.getters.getPageData.imgsPath + ( this.isAuto ? 'libretti/' : 'scontrini/') + this.img
      },
      isPDF () {
          return this.img.split('.').pop() === 'pdf'
      },
      km () {
        return this.item.titolo === "ANDATA/RITORNO" ? this.item.km * 2 : this.item.km
      },
      importo () {
        return (Number(this.item.importo).toFixed(2) || 0)
      },
      lek () {
        return (Number(this.item.is_lek).toFixed(2) || 0)   
      }
  },
  watch: {},
  methods: {
    showImgPrew() {
      this.imgPrev = true;
    },
    closeImgPrewHandler() {
      this.imgPrev = false;
    },
    changeStato(item, stato) {
      let $that = this;
      if ('CONFIRM' !== stato) {
        this.$swal({
          html: `<div class="font-weight-medium my-2 headline">
                      Inserisci il motivo del'operazione!
                    </div>`,
          target: this.$refs.targetModal.$el,
          showCancelButton: true,
          confirmButtonText: "Conferma",
          cancelButtonText: "Cancella",
          input: "text",
          inputClass: "v-text-field__slot",
          inputAttributes: {
            autocapitalize: "off"
          },
          showLoaderOnConfirm: true,
          preConfirm: motivo => {
            $that.$emit("on-confirm", item, stato, motivo);
            return true;
          },
          allowOutsideClick: () => !$that.$swal.isLoading()
        });
      } else {
        this.$emit("on-confirm", item, stato, "");
      }
    }
  }
};
</script>

<style lang="scss">
  .title__wrap {
      display: flex;
      .v-chip {
        height: auto !important;
        .v-chip__content {
            height: 16px !important;
        }
      }
  }
.modal-image-prewiev__wrap-content {
  height: calc(100% - 64px);
  modal-image-prewiev__content {
    height: 100%;
    img {
      display: block;
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/VerificaNoteDettaglioItem.vue